let Utility = {
    getUrlParameter(sParam) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(sParam);
    }
};

export default Utility;
